'use client';

import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { useDispatch, useSelector } from 'react-redux';
import { mainSelector, RoomFloorModalOpen } from '../../store/slices/main.slice';
import IntFloorPlanPianoTerra1 from './vt-floor-map-contents/Piano terra/Piano_Terra_P1-Piazza';
import IntFloorPlanPianoTerra2 from './vt-floor-map-contents/Piano terra/Piano_Terra_P2-Ingresso';
import IntFloorPlanPianoTerra3 from './vt-floor-map-contents/Piano terra/Piano_Terra_P3-Cortile';
import IntFloorPlanPianoTerra4 from './vt-floor-map-contents/Piano terra/Piano_Terra_P4-Giardino';
import IntFloorPlanPianoSecondo1 from './vt-floor-map-contents/Piano secondo/Piano_Secondo_P1_SALA-A1';
import IntFloorPlanPianoTerra6 from './vt-floor-map-contents/Piano terra/Piano_Terra_P6-Cappelletta';
import IntFloorPlanPianoSecondo2 from './vt-floor-map-contents/Piano secondo/Piano_Secondo_P2-SALA-A2';
import IntFloorPlanPianoSecondo3 from './vt-floor-map-contents/Piano secondo/Piano_Secondo_P3-SALA-A3';
import IntFloorPlanPianoSecondo4 from './vt-floor-map-contents/Piano secondo/Piano_Secondo_P4-SALA-A5';
import IntFloorPlanPianoSecondo5 from './vt-floor-map-contents/Piano secondo/Piano_Secondo_P5-SALA-B';
import IntFloorPlanPianoSecondo6 from './vt-floor-map-contents/Piano secondo/Piano_Secondo_P6-SALA-C';
import IntFloorPlanPianoSecondo7 from './vt-floor-map-contents/Piano secondo/Piano_Secondo_P7-SALA-D3';
import IntFloorPlanPianoSecondo8 from './vt-floor-map-contents/Piano secondo/Piano_Secondo_P8-SALA-E2_A-B';
import IntFloorPlanPianoSecondo9 from './vt-floor-map-contents/Piano secondo/Piano_Secondo_P10-SALA-E3';
import IntFloorPlanPianoSecondo10 from './vt-floor-map-contents/Piano secondo/Piano_Secondo_P11-SALA-E4';
import IntFloorPlanPianoSecondo11 from './vt-floor-map-contents/Piano secondo/Piano_Secondo_P12-SALA-E6';
import IntFloorPlanPianoSecondo12 from './vt-floor-map-contents/Piano secondo/Piano_Secondo_P12-Torre';
import IntFloorPlanPianoSecondo13 from './vt-floor-map-contents/Piano secondo/Piano_Secondo_P14-SALA-F1';
import IntFloorPlanPianoSecondo14 from './vt-floor-map-contents/Piano secondo/Piano_Secondo_P1_SALA-A1333';
import IntFloorPlanSotterranei1 from './vt-floor-map-contents/Sotterranei/Piano_Seminterrato_P1_Sala-F1';
import IntFloorPlanSotterranei2 from './vt-floor-map-contents/Sotterranei/Piano_Seminterrato_P2_Disimpegno';
import IntFloorPlanSotterranei3 from './vt-floor-map-contents/Sotterranei/Piano_Seminterrato_P3_Sala-A2';
import IntFloorPlanSotterranei4 from './vt-floor-map-contents/Sotterranei/Piano_Seminterrato_P4_Sala-B1';
import IntFloorPlanSotterranei5 from './vt-floor-map-contents/Sotterranei/Piano_Seminterrato_P5_Sala-D';
import IntFloorPlanSotterranei6 from './vt-floor-map-contents/Sotterranei/Piano_Seminterrato_P6_Sala-B4_alto-basso';
import IntFloorPlanSotterranei7 from './vt-floor-map-contents/Sotterranei/Piano_Seminterrato_P8_Sala-A1';
import IntFloorPlanPianoTerra7 from './vt-floor-map-contents/Piano terra/Piano_Terra_P7-Scalone';
import IntFloorPlanPianoPrimo1 from './vt-floor-map-contents/Piano primo/Piano_Primo_P1_SALA-A1';
import IntFloorPlanPianoPrimo2 from './vt-floor-map-contents/Piano primo/Piano_Primo_P1_SALA-A2';
import IntFloorPlanPianoPrimo3 from './vt-floor-map-contents/Piano primo/Piano_Primo_P1_SALA-A3';
import IntFloorPlanPianoPrimo4 from './vt-floor-map-contents/Piano primo/Piano_Primo_P1_SALA-A4';
import IntFloorPlanPianoPrimo5 from './vt-floor-map-contents/Piano primo/Piano_Primo_P1_SALA-A7';
import IntFloorPlanPianoPrimo6 from './vt-floor-map-contents/Piano primo/Piano_Primo_P1_SALA-B2';
import IntFloorPlanPianoPrimo7 from './vt-floor-map-contents/Piano primo/Piano_Primo_P1_SALA-B4';
import IntFloorPlanPianoPrimo8 from './vt-floor-map-contents/Piano primo/Piano_Primo_P1_SALA-C4';
import IntFloorPlanPianoPrimo9 from './vt-floor-map-contents/Piano primo/Piano_Primo_P1_SALA-D2';
import IntFloorPlanPianoPrimo10 from './vt-floor-map-contents/Piano primo/Piano_Primo_P1_SALA-D3';
import IntFloorPlanPianoPrimo11 from './vt-floor-map-contents/Piano primo/Piano_Primo_P1_SALA-D1';
import IntFloorPlanPianoPrimo12 from './vt-floor-map-contents/Piano primo/Piano_Primo_P1_SALA-D5';
import IntFloorPlanPianoPrimo13 from './vt-floor-map-contents/Piano primo/Piano_Primo_P1_SALA-G';
import IntFloorPlanPianoPrimo14 from './vt-floor-map-contents/Piano primo/Piano_Primo_P1_SALA-H1';
import IntFloorPlanPianoPrimo15 from './vt-floor-map-contents/Piano primo/Piano_Primo_P1_SALA-H3';
import { useTranslation } from 'react-i18next';
import IntFloorPlanPianoSecondo8Bis from './vt-floor-map-contents/Piano secondo/Piano_Secondo_P8-SALA-E2_A-Bis';

function useVisualViewportSize(): { vw: number; vh: number } {
    const getSize = () => {
        const vv: any = (typeof window !== 'undefined' && (window as any).visualViewport) || null;
        return {
            vw: Math.round(vv?.width || (typeof window !== 'undefined' ? window.innerWidth : 0)),
            vh: Math.round(vv?.height || (typeof window !== 'undefined' ? window.innerHeight : 0)),
        };
    };

    const [size, setSize] = useState<{ vw: number; vh: number }>(() => (typeof window !== 'undefined' ? getSize() : { vw: 0, vh: 0 }));

    useEffect(() => {
        if (typeof window === 'undefined') return;
        const vv: any = (window as any).visualViewport;
        const onResize = () => setSize(getSize());
        vv?.addEventListener('resize', onResize);
        window.addEventListener('resize', onResize);
        window.addEventListener('orientationchange', onResize);
        const id = window.setInterval(onResize, 250);
        return () => {
            vv?.removeEventListener('resize', onResize);
            window.removeEventListener('resize', onResize);
            window.removeEventListener('orientationchange', onResize);
            window.clearInterval(id);
        };
    }, []);

    return size;
}

type RotatedProps = { onClose: () => void; children: React.ReactNode };

function useElementSize<T extends HTMLElement>() {
    const ref = React.useRef<T | null>(null);
    const [size, setSize] = React.useState({ w: 0, h: 0 });

    React.useEffect(() => {
        if (!ref.current) return;
        const el = ref.current;
        const ro = new ResizeObserver(([entry]) => {
            const { width, height } = entry.contentRect;
            setSize({ w: Math.round(width), h: Math.round(height) });
        });
        ro.observe(el);
        return () => ro.disconnect();
    }, []);

    return { ref, ...size };
}

const RotatedMobileContainer: React.FC<RotatedProps> = ({ onClose, children }) => {
    const { ref: outerRef, w: pw, h: ph } = useElementSize<HTMLDivElement>();
    const ready = pw > 0 && ph > 0;

    // Base pre-rotazione: la mettiamo "swappata"
    const baseW = ph; // width prima della rotazione
    const baseH = pw; // height prima della rotazione

    // Dopo rotate(90deg):
    // larghezza visiva = baseH, altezza visiva = baseW
    const scale = ready ? Math.min(pw / baseH, ph / baseW) : 1;

    const outerStyle: React.CSSProperties = {
        position: 'relative',
        width: '100%',
        height: '100%',
        overflow: 'hidden', // va bene, non sforeremo
    };

    const rotatedStyle: React.CSSProperties = {
        position: 'absolute',
        left: '50%',
        top: '50%',
        width: `${baseW}px`,
        height: `${baseH}px`,
        transform: `translate(-50%, -50%) rotate(90deg) scale(${scale})`,
        transformOrigin: 'center center',
        boxSizing: 'border-box',
        padding: '40px',
        display: 'flex'
    };

    return (
        <div ref={outerRef} style={outerStyle} onClick={onClose}>
            {ready && (
                <div style={rotatedStyle} onClick={(e) => e.stopPropagation()}>
                    {children}
                </div>
            )}
        </div>
    );
};



const RoomFloorMapModalRoot: React.FC = () => {
    const dispatch: any = useDispatch();
    const { roomFloorModal, currentRoomIndex } = useSelector(mainSelector);
    const { t }: any = useTranslation();

    useEffect(() => {
        dispatch(RoomFloorModalOpen(false));
    }, [dispatch]);

    const onClose = () => {
        dispatch(RoomFloorModalOpen(false));
    };

    return (
        <AnimatePresence>
            {roomFloorModal.open && (
                <motion.div
                    key="shapeModal-root"
                    className="fixed inset-0 bg-black/40 flex justify-center items-center z-[100]"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    onClick={onClose}
                >
                    <motion.div
                        key="shapeModal-content"
                        className="relative w-full h-full bg-[#302e2b] flex flex-col items-center justify-center p-[10px] lg:p-[80px] py-[10px] lg:py-[120px]"
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1, transition: { duration: 0.5 } }}
                        exit={{ opacity: 0, transition: { duration: 0.5 } }}
                        onClick={(e) => e.stopPropagation()}
                    >
                        {/* DESKTOP / TABLET >= lg */}
                        <div className="w-[80vw] lg:w-[60vw] hidden lg:block">
                            <div className="flex flex-row items-center justify-between absolute top-0 left-0 w-[100vw] py-[27px] px-[40px]">
                                <img src="/images/GNDM logo full.png" alt="Header GNDM Logo" className="max-h-[30px] cursor-pointer hidden lg:block" />
                                <img src="/images/GNDM acronimo orizzontale white.png" alt="Header GNDM Logo" className="max-h-[20px] cursor-pointer lg:hidden block" />
                                <button onClick={onClose} className="text-white text-md font-untitledSans leading-[15px]">X</button>
                            </div>
                            <div className="flex flex-col gap-[30px] items-center w-full mt-[-50px]">
                                <h4 className="text-white text-xs lg:text-base font-untitledSans mb-[30px] text-center">{t('vt.virtual_tour_floor_map_modal')}:</h4>
                                <div className="w-full max-h-[300px] lg:max-h-[200px] xl:max-h-[300px] flex flex-col items-center justify-center cursor-pointer">
                                    {currentRoomIndex === 1 && <IntFloorPlanPianoTerra1 />}
                                    {currentRoomIndex === 2 && <IntFloorPlanPianoTerra2 />}
                                    {currentRoomIndex === 3 && <IntFloorPlanPianoTerra3 />}
                                    {currentRoomIndex === 4 && <IntFloorPlanPianoTerra4 />}
                                    {currentRoomIndex === 5 && <IntFloorPlanPianoTerra6 />}

                                    {currentRoomIndex === 6 && <IntFloorPlanPianoSecondo1 />}
                                    {currentRoomIndex === 7 && <IntFloorPlanPianoSecondo2 />}
                                    {currentRoomIndex === 8 && <IntFloorPlanPianoSecondo3 />}
                                    {currentRoomIndex === 9 && <IntFloorPlanPianoSecondo4 />}
                                    {currentRoomIndex === 10 && <IntFloorPlanPianoSecondo5 />}
                                    {currentRoomIndex === 11 && <IntFloorPlanPianoSecondo6 />}
                                    {currentRoomIndex === 12 && <IntFloorPlanPianoSecondo7 />}
                                    {currentRoomIndex === 13 && <IntFloorPlanPianoSecondo8 />}
                                    {currentRoomIndex === 14 && <IntFloorPlanPianoSecondo8Bis />}
                                    {currentRoomIndex === 15 && <IntFloorPlanPianoSecondo9 />}
                                    {currentRoomIndex === 16 && <IntFloorPlanPianoSecondo10 />}
                                    {currentRoomIndex === 17 && <IntFloorPlanPianoSecondo11 />}
                                    {currentRoomIndex === 18 && <IntFloorPlanPianoSecondo12 />}
                                    {currentRoomIndex === 19 && <IntFloorPlanPianoSecondo13 />}
                                    {currentRoomIndex === 20 && <IntFloorPlanPianoSecondo14 />}

                                    {currentRoomIndex === 21 && <IntFloorPlanSotterranei1 />}
                                    {currentRoomIndex === 22 && <IntFloorPlanSotterranei2 />}
                                    {currentRoomIndex === 23 && <IntFloorPlanSotterranei3 />}
                                    {currentRoomIndex === 24 && <IntFloorPlanSotterranei4 />}
                                    {currentRoomIndex === 25 && <IntFloorPlanSotterranei5 />}
                                    {currentRoomIndex === 26 && <IntFloorPlanSotterranei6 />}
                                    {currentRoomIndex === 27 && <IntFloorPlanSotterranei6 />}
                                    {currentRoomIndex === 28 && <IntFloorPlanSotterranei7 />}

                                    {currentRoomIndex === 29 && <IntFloorPlanPianoTerra7 />}
                                    {currentRoomIndex === 30 && <IntFloorPlanPianoPrimo1 />}
                                    {currentRoomIndex === 31 && <IntFloorPlanPianoPrimo2 />}
                                    {currentRoomIndex === 32 && <IntFloorPlanPianoPrimo3 />}
                                    {currentRoomIndex === 33 && <IntFloorPlanPianoPrimo4 />}
                                    {currentRoomIndex === 34 && <IntFloorPlanPianoPrimo5 />}
                                    {currentRoomIndex === 35 && <IntFloorPlanPianoPrimo6 />}
                                    {currentRoomIndex === 36 && <IntFloorPlanPianoPrimo7 />}
                                    {currentRoomIndex === 37 && <IntFloorPlanPianoPrimo8 />}
                                    {currentRoomIndex === 38 && <IntFloorPlanPianoPrimo9 />}
                                    {currentRoomIndex === 39 && <IntFloorPlanPianoPrimo10 />}
                                    {currentRoomIndex === 40 && <IntFloorPlanPianoPrimo11 />}
                                    {currentRoomIndex === 41 && <IntFloorPlanPianoPrimo12 />}
                                    {currentRoomIndex === 42 && <IntFloorPlanPianoPrimo13 />}
                                    {currentRoomIndex === 43 && <IntFloorPlanPianoPrimo14 />}
                                    {currentRoomIndex === 44 && <IntFloorPlanPianoPrimo15 />}
                                </div>
                            </div>
                        </div>

                        {/* MOBILE < lg */}
                        <div className="lg:hidden w-full h-full portrait-lock px-[10px]">
                                <div className="w-full h-full flex flex-col">
                                    <div className="h-[64px] flex flex-row items-center justify-between">
                                        <img src={'/images/GNDM acronimo orizzontale white.png'} alt="Header GNDM Logo" className="max-h-[20px]" />
                                        <button onClick={onClose} className="text-white text-[32px] font-untitledSans mt-[-10px]">x</button>
                                    </div>
                                    <h4 className="text-white text-xs font-untitledSans">{t('vt.virtual_tour_floor_map_modal')}:</h4>
                                    <div className="flex-1 min-h-0 w-full relative overflow-hidden">
                                        <RotatedMobileContainer onClose={onClose}>
                                            {currentRoomIndex === 1 && <IntFloorPlanPianoTerra1/>}
                                            {currentRoomIndex === 2 && <IntFloorPlanPianoTerra2/>}
                                            {currentRoomIndex === 3 && <IntFloorPlanPianoTerra3/>}
                                            {currentRoomIndex === 4 && <IntFloorPlanPianoTerra4/>}
                                            {currentRoomIndex === 5 && <IntFloorPlanPianoTerra6/>}

                                            {currentRoomIndex === 6 && <IntFloorPlanPianoSecondo1/>}
                                            {currentRoomIndex === 7 && <IntFloorPlanPianoSecondo2/>}
                                            {currentRoomIndex === 8 && <IntFloorPlanPianoSecondo3/>}
                                            {currentRoomIndex === 9 && <IntFloorPlanPianoSecondo4/>}
                                            {currentRoomIndex === 10 && <IntFloorPlanPianoSecondo5/>}
                                            {currentRoomIndex === 11 && <IntFloorPlanPianoSecondo6/>}
                                            {currentRoomIndex === 12 && <IntFloorPlanPianoSecondo7/>}
                                            {currentRoomIndex === 13 && <IntFloorPlanPianoSecondo8/>}
                                            {currentRoomIndex === 14 && <IntFloorPlanPianoSecondo8Bis/>}
                                            {currentRoomIndex === 15 && <IntFloorPlanPianoSecondo9/>}
                                            {currentRoomIndex === 16 && <IntFloorPlanPianoSecondo10/>}
                                            {currentRoomIndex === 17 && <IntFloorPlanPianoSecondo11/>}
                                            {currentRoomIndex === 18 && <IntFloorPlanPianoSecondo12/>}
                                            {currentRoomIndex === 19 && <IntFloorPlanPianoSecondo13/>}
                                            {currentRoomIndex === 20 && <IntFloorPlanPianoSecondo14/>}

                                            {currentRoomIndex === 21 && <IntFloorPlanSotterranei1/>}
                                            {currentRoomIndex === 22 && <IntFloorPlanSotterranei2/>}
                                            {currentRoomIndex === 23 && <IntFloorPlanSotterranei3/>}
                                            {currentRoomIndex === 24 && <IntFloorPlanSotterranei4/>}
                                            {currentRoomIndex === 25 && <IntFloorPlanSotterranei5/>}
                                            {currentRoomIndex === 26 && <IntFloorPlanSotterranei6/>}
                                            {currentRoomIndex === 27 && <IntFloorPlanSotterranei6/>}
                                            {currentRoomIndex === 28 && <IntFloorPlanSotterranei7/>}

                                            {currentRoomIndex === 29 && <IntFloorPlanPianoTerra7/>}
                                            {currentRoomIndex === 30 && <IntFloorPlanPianoPrimo1/>}
                                            {currentRoomIndex === 31 && <IntFloorPlanPianoPrimo2/>}
                                            {currentRoomIndex === 32 && <IntFloorPlanPianoPrimo3/>}
                                            {currentRoomIndex === 33 && <IntFloorPlanPianoPrimo4/>}
                                            {currentRoomIndex === 34 && <IntFloorPlanPianoPrimo5/>}
                                            {currentRoomIndex === 35 && <IntFloorPlanPianoPrimo6/>}
                                            {currentRoomIndex === 36 && <IntFloorPlanPianoPrimo7/>}
                                            {currentRoomIndex === 37 && <IntFloorPlanPianoPrimo8/>}
                                            {currentRoomIndex === 38 && <IntFloorPlanPianoPrimo9/>}
                                            {currentRoomIndex === 39 && <IntFloorPlanPianoPrimo10/>}
                                            {currentRoomIndex === 40 && <IntFloorPlanPianoPrimo11/>}
                                            {currentRoomIndex === 41 && <IntFloorPlanPianoPrimo12/>}
                                            {currentRoomIndex === 42 && <IntFloorPlanPianoPrimo13/>}
                                            {currentRoomIndex === 43 && <IntFloorPlanPianoPrimo14/>}
                                            {currentRoomIndex === 44 && <IntFloorPlanPianoPrimo15/>}
                                        </RotatedMobileContainer>
                                    </div>
                                </div>
                        </div>
                    </motion.div>
                </motion.div>
            )}
        </AnimatePresence>
    );
};

export default RoomFloorMapModalRoot;
